import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useGetAppVersion = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("appversion/list");
    }, options);
};

export const useUpdateAppVersion = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("appversion/update-app-version/list", data);
    }, options);
};
